import { computed as o, createElementBlock as l, openBlock as m } from "vue";
import { startCase as u, camelCase as h } from "lodash-es";
import { icons as s } from "../../icons/index.js";
import { Unknown as g } from "../../icons/unknown.js";
import { UnknownCountries as w } from "../../icons/unknown-countries.js";
import { UnknownFinancial as d } from "../../icons/unknown-financial.js";
const p = ["width", "height", "viewBox", "aria-label", "innerHTML"], L = /* @__PURE__ */ Object.assign({
  name: "DsIcon"
}, {
  __name: "icon",
  props: {
    name: {
      type: String,
      required: !0
    },
    category: {
      type: String,
      required: !0
    },
    ariaLabel: {
      type: String,
      default: ""
    }
  },
  setup(i) {
    const a = (e) => u(h(e)).replace(/ /g, ""), n = i, c = o(() => n.category === "countries" ? w : n.category === "financial" ? d : g), r = o(() => {
      var e;
      return s && ((e = s[a(n.category)]) == null ? void 0 : e[a(n.name)]) || c.value;
    }), t = o(() => ({ width: r.value.dimensions.width, height: r.value.dimensions.height }));
    return (e, f) => (m(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.value.width,
      height: t.value.height,
      viewBox: `0 0 ${t.value.width} ${t.value.height}`,
      "aria-label": i.ariaLabel || i.name,
      role: "img",
      class: "icon",
      innerHTML: r.value.content
    }, null, 8, p));
  }
});
export {
  L as default
};
